import { MedTableSettingsLocal } from "../types.local";

export const MED_TABLE_DEFAULT_SETTING: MedTableSettingsLocal = {
  colMinWidth: "5rem",
  colMaxWidth: "25rem",
  emptyMessage: "No data to display",
  defaultValue: "–",
  visibleHead: true,
  stickyTop: "0px",
  stickyLeft: "0px",
  rowDataClass: "",
  rowDataClassFn: () => "",
  colspan: 1,
};
